import React, {useEffect, useState} from 'react';


import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {actions} from '../../../redux/actions';
import {Link} from "react-router-dom";
import {Container, LogoSection, SalesTitle, CompanySelector} from "./styles";
import {getProfile} from "../../../services/User";
import {getCompanies, getCurrentCompany} from "../../../services/Company";
import ImgUserDefault from '../../../assets/img/undraw_profile.svg';
import logo from '../../../assets/img/logo.png';

function Topbar () {
  const dispatch = useDispatch();
  const location = useLocation();
  const isSalesPage = location.pathname === '/sales';
  const { urlProfilePhoto } = useSelector(
    (state) => state.UserReducer
  );
  const { currentCompany, companies, isAdmin } = useSelector(
    (state) => state.CompanyReducer
  );
  const [userRoles, setUserRoles] = useState({ isAdmin: false, isOperator: false });

  function logout() {
    // Fechar o dropdown manualmente
    const dropdown = document.querySelector('#userDropdown');
    if (dropdown) {
      const dropdownMenu = dropdown.nextElementSibling;
      if (dropdownMenu && dropdownMenu.classList.contains('show')) {
        dropdownMenu.classList.remove('show');
        dropdown.setAttribute('aria-expanded', 'false');
      }
    }
    
    localStorage.clear();
    window.location="/";
  }
  
  function handleLogoutClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Pequeno delay para garantir que o evento seja processado
    setTimeout(() => {
      logout();
    }, 100);
  }

  useEffect(() => {
    getProfile().then((data) => {
      if (!data) {
        return;
      }

      const userData = data.data.data;
      dispatch(actions.setUrlProfilePhoto(userData.urlProfilePhoto));
      dispatch(actions.setPublicCode(userData.publicCode));

      // Verificar roles do usuário
      const roles = userData.roles || [];
      const isAdminUser = roles.includes('ROLE_ADMIN');
      const isOperatorUser = roles.includes('ROLE_OPERATOR');
      
      setUserRoles({ isAdmin: isAdminUser, isOperator: isOperatorUser });
      dispatch(actions.setUserRoles(isAdminUser, isOperatorUser));

      // Carregar empresas se for ADMIN
      if (isAdminUser) {
        getCompanies().then((companiesData) => {
          if (companiesData && companiesData.data && companiesData.data.data) {
            dispatch(actions.setCompanies(companiesData.data.data));
            
            // Verificar se há empresa salva no localStorage e usar imediatamente
            const savedCompanyId = localStorage.getItem('@current_company_id');
            const savedCompany = savedCompanyId 
              ? companiesData.data.data.find(c => c.id === savedCompanyId)
              : null;
            
            // Se houver empresa salva, usar imediatamente
            if (savedCompany) {
              dispatch(actions.setCurrentCompany(savedCompany));
              localStorage.setItem('@current_company_id', savedCompany.id);
            }
            
            // Carregar empresa atual da API (pode sobrescrever a salva se diferente)
            getCurrentCompany().then((currentData) => {
              if (currentData && currentData.data && currentData.data.data) {
                const company = currentData.data.data;
                // Só atualizar se for diferente da empresa salva
                if (!savedCompany || company.id !== savedCompany.id) {
                  dispatch(actions.setCurrentCompany(company));
                  localStorage.setItem('@current_company_id', company.id);
                }
              } else if (!savedCompany && companiesData.data.data.length > 0) {
                // Se não houver empresa salva nem da API, usar a primeira
                const firstCompany = companiesData.data.data[0];
                dispatch(actions.setCurrentCompany(firstCompany));
                localStorage.setItem('@current_company_id', firstCompany.id);
              }
            });
          }
        });
      } else if (isOperatorUser) {
        // OPERADOR: carregar empresa vinculada
        getCurrentCompany().then((currentData) => {
          if (currentData && currentData.data && currentData.data.data) {
            const company = currentData.data.data;
            dispatch(actions.setCurrentCompany(company));
            dispatch(actions.setCompanies([company]));
            localStorage.setItem('@current_company_id', company.id);
          }
        });
      }
    });
  }, [dispatch]);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value;
    const selectedCompany = companies.find(c => c.id === companyId);
    
    if (selectedCompany) {
      dispatch(actions.setCurrentCompany(selectedCompany));
      localStorage.setItem('@current_company_id', companyId);
      // Não recarrega mais a página, permite atualização dinâmica
    }
  };

  return (
    <Container className="navbar navbar-expand navbar-light topbar mb-4 static-top shadow">
      {isSalesPage ? (
        <LogoSection>
          <Link to="/dashboard">
            <img src={logo} alt="Borracharia Major" />
          </Link>
          <SalesTitle>
            Sistema de Vendas{currentCompany?.name ? ` - ${currentCompany.name}` : ''}
          </SalesTitle>
        </LogoSection>
      ) : (
        <>
          <div className="d-md-none d-flex align-items-center mr-3" style={{ gap: '12px' }}>
            <button onClick={() => { dispatch(actions.clickMenuOpen()); }}  id="sidebarToggleTop" className="btn btn-link rounded-circle" style={{ padding: '0', margin: '0' }}>
              <i className="fa fa-bars"/>
            </button>
            <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img src={logo} alt="Borracharia Major" style={{ height: '40px', width: 'auto', objectFit: 'contain' }} />
            </Link>
          </div>
          {isAdmin && companies.length > 0 && (
            <CompanySelector>
              <label htmlFor="company-selector">Empresa:</label>
              <select
                id="company-selector"
                value={currentCompany?.id || ''}
                onChange={handleCompanyChange}
              >
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.name}
                  </option>
                ))}
              </select>
            </CompanySelector>
          )}
        </>
      )}
      <ul className="navbar-nav ml-auto">
        <li className="nav-item dropdown no-arrow">
          <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span className="mr-2 d-none d-lg-inline text-white small font-weight-bold">{localStorage.getItem('@name')}</span>
            <img className="img-profile rounded-circle" src={urlProfilePhoto ? `${process.env.REACT_APP_API_ENDPOINT}${urlProfilePhoto}` : ImgUserDefault} style={{
              borderRadius: '5px',
              border: '1px solid #000'
            }}/>
          </a>
          <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
            <Link to="/profile" className="dropdown-item">
              <i className="far fa-user fa-sm fa-fw"></i>
              <span>Perfil</span>
            </Link>
            <div 
              className="dropdown-item" 
              role="button"
              tabIndex={0}
              onClick={handleLogoutClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleLogoutClick(e);
                }
              }}
            >
              <i className="fas fa-sign-out-alt fa-sm fa-fw"></i>
              <span>Sair</span>
            </div>
          </div>
        </li>
      </ul>
    </Container>
  )
}

export default Topbar;